import { render } from "./Acesso.vue?vue&type=template&id=603d17a2"
import script from "./Acesso.vue?vue&type=script&lang=js"
export * from "./Acesso.vue?vue&type=script&lang=js"

import "./Acesso.vue?vue&type=style&index=0&id=603d17a2&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__